export default __webpack_public_path__ + "static/media/5.fe594727.jpg";